import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// components
import { Select } from '../static/Select';
// functions
import { toast } from 'react-toastify';
import { findOption } from 'functions/selects';
// state
import { getSoldiers } from 'store/base/soldiers/operations';

export class SoldierSelect extends Component {

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,

    classId: PropTypes.any,
    classIds: PropTypes.array,

    schoolId: PropTypes.any,
  }

  static defaultProps = {
    showAllOption: false,
    registeredOnly: false,

    // I don't know why the soldiers are reloaded so often
    // being that **all** soldiers are loaded and the filters are only applied at render
    // the onlyReloadSoldiersIfNotLoaded prop stops soldiers from being reloaded unless they arn't loaded yet
    // hopefully over time this can be added everywhere that the SoldierSelect is used and become the default
    onlyReloadSoldiersIfNotLoaded: false
  }

  componentDidMount() {
    this.loadSoldiers();
  }

  // Reload when the school or platoon changes so the dropdown is populated
  // from the latest user response. Only a school change invalidates the
  // currently selected soldier.
  componentDidUpdate({ schoolId: prevSchoolId, classId: prevClassId }) {
    const { schoolId, classId, value, isClearable, isMulti } = this.props;
    const schoolChanged = prevSchoolId !== schoolId;
    const platoonChanged = prevClassId !== classId;

    if (schoolChanged || platoonChanged) {
      this.loadSoldiers();
      // A soldier from the previous school is no longer valid. Changing
      // platoons should keep the current selection until another is chosen.
      //
      // Check which school the soldier is actually in before clearing: the
      // mark page's serial quick-select sets the soldier and moves the school
      // to theirs in one step, so the soldier already belongs to the NEW
      // school. Clearing them threw away a correct lookup. school_id arrives
      // as a string from GET /core/users, so compare as strings.
      if (schoolChanged && value && !isMulti && this.props.onChange) {
        const selected = (this.props.soldiers || [])
          .find(s => String(s.user_id) === String(value));
        if (!selected || String(selected.school_id) !== String(schoolId))
          this.props.onChange(false);
      }
      return;
    }

    const options = this.getOptions();
    if (options.length === 0 || isMulti)
      return;

    const selected = findOption(options, value);
    if (selected)
      return;

    // Keep the current soldier even if the platoon filter no longer lists them.
    // Only auto-select a default when nothing is chosen yet.
    if (!value && !isClearable)
      this.props.onChange(options[0]);
  }

  loadSoldiers = () => {
    if (!this.props.onlyReloadSoldiersIfNotLoaded || !(this.props.soldiers && this.props.soldiers.length > 0)) {
      return this.props.getSoldiers()
        .catch(e => toast.error(e.message));
    }
  }

  getSelectedIds = () => {
    const { value, values } = this.props;
    if (values && values.length)
      return values.map(String);
    if (value !== undefined && value !== null && value !== false)
      return [String(value)];
    return [];
  }

  getOptions = () => {
    let {
      showAllOption, isMulti,
      schoolId, registeredOnly,
      classId, classIds, soldiers
    } = this.props;

    // make sure the school id is valid
    if (!schoolId) {
      return [];
    } else {
      schoolId = schoolId.toString();
    }

    let options = soldiers;

    // only soldiers in the classId from props
    if (classId) {
      classId = classId.toString();
      options = options.filter(soldier => String(soldier.class_id) === classId);
      // allow for multi select
    } else if (classIds && classIds.length > 0) {
      classIds = classIds.map(id => id.toString());
      options = options.filter(soldier => classIds.includes(String(soldier.class_id)));
      // make sure the soldier is in a platoon
    } else {
      options = options.filter(soldier => !!soldier.class_id);
    }

    // limit to school ID
    if (schoolId) {
      options = options.filter(soldier => String(soldier.school_id) === schoolId);
    }

    // limit to registered only
    if (registeredOnly) {
      options = options.filter(soldier => !!soldier.user_registered);
    }

    // Keep already-selected soldiers in the options list even if they fall
    // outside the current platoon filter (e.g. platoon was cleared/changed).
    const selectedIds = this.getSelectedIds();
    if (selectedIds.length > 0) {
      const present = new Set(options.map(s => String(s.user_id)));
      const extras = soldiers.filter(s =>
        selectedIds.includes(String(s.user_id))
        && !present.has(String(s.user_id))
        && String(s.school_id) === schoolId
        && (!registeredOnly || !!s.user_registered)
      );
      if (extras.length)
        options = extras.concat(options);
    }

    // map them to what react-select expects
    options = options.map(({ user_id, first, last }) => (
      { value: user_id, label: `${first} ${last}` }
    ));
    // add special options
    if (showAllOption && !isMulti) {
      options.unshift({ value: false, label: 'All Soldiers' });
    }
    // and return the options
    return options;
  }

  filter = (option, value) => option.label.toLowerCase().includes(value.toLowerCase());

  render() {
    const { value, loading, values, showAllOption, soldiers } = this.props;

    let options = this.getOptions();
    let selected;
    // support single value
    if (value)
      selected = findOption(options, value) || null;
    else if (value === false && showAllOption && !loading)
      selected = options[0];
    else if (value === false)
      selected = false;
    // support multiple values
    if (values)
      selected = values
        .map(value => findOption(options, value) || false)
        .filter(value => value !== false);

    // Don't blank the control while refetching if we already have soldiers
    options = (loading && !(soldiers && soldiers.length)) ? [] : options;

    return (
      <Select
        {...this.props}
        value={selected}
        options={options}
        isLoading={loading}
        filterOption={this.filter} />
    );
  }
}

const mapStateToProps = ({ base }) => {
  return {
    loading: base.soldiers.loading,
    soldiers: base.soldiers.soldiers,
  };
}

export default connect(mapStateToProps, { getSoldiers })(SoldierSelect);



// WEBPACK FOOTER //
// ./src/components/selects/redux/SoldierSelect.jsx